import styled from "styled-components";

export default styled.label`
  position: absolute;
  bottom: -12px;
  color: red;
  padding: 0 5px;
  font-size: xx-small;
  max-width: ${(props) => props.width || "220px"};
  width: 100%;
`;
